import NewUserPage from "@/components/screens/user/new";

export default function NewUser() {
  return <NewUserPage />;
}
